import constants from "../../../constants";
import { v4 as uuidv4 } from "uuid";
import * as moment from "moment";
export const leaveClasses = (statusId) => {
  const pendingCheck = statusId === constants.agendaType.PENDINGLEAVE;

  return {
    main: pendingCheck ? "red-bg" : "green-bg",
    borderLeft: pendingCheck ? "border-left-red" : "border-left-dark-green",
    Highlighter: pendingCheck ? "dark-red-bg" : "dark-green-bg",
    text: `scheduler.agenda.${pendingCheck ? "pendingLeave" : "approvedLeave"}`,
  };
};
export const matchForLeaves = (event, agendaTypes) => {
  //    { title: t("accountOwner.leaveApproved"), type: 2 },
  //    { title: t("accountOwner.leavePending"), type: 9 },  type 9 will be matched with 1 in leave statusId
  // Status 1 represents 'Pending', but we're matching it with 9 to filter it because we're using local values for the pending leave status.
  //  Pending =constants.agendaType.PENDINGLEAVE = 1
  //  Approved =constants.agendaType.APPROVEDLEAVE = 2
  return agendaTypes.includes(
    event.statusId === constants.agendaType.PENDINGLEAVE ? 9 : event.statusId,
  );
};
export const highlightClassWhenEventWillExist = ({
  cellDate,
  allData,
  i,
  key = "date",
  styles,
  disabledDates,
  type,
}) => {
  let isSelectedIfRepeatTypeHasValue = false;
  let rightBorderRemove = false,
    leftBorderRemove = false;
  if (disabledDates) {
    isSelectedIfRepeatTypeHasValue = disabledDates({ date: cellDate });
    if (!i && isSelectedIfRepeatTypeHasValue) {
      rightBorderRemove = disabledDates({
        date: new Date(allData[i + 1][key]),
      });
    } else if (
      isSelectedIfRepeatTypeHasValue &&
      i &&
      allData.length - 1 === i
    ) {
      leftBorderRemove = disabledDates({
        date: new Date(allData[i - 1][key]),
      });
    } else if (isSelectedIfRepeatTypeHasValue && i && allData.length - 1 > i) {
      rightBorderRemove = disabledDates({
        date: new Date(allData[i + 1][key]),
      });
      leftBorderRemove = disabledDates({
        date: new Date(allData[i - 1][key]),
      });
    }
    if (type === "holiday") {
      if (leftBorderRemove && rightBorderRemove) return "a";
      if (
        isSelectedIfRepeatTypeHasValue &&
        !leftBorderRemove &&
        !rightBorderRemove
      ) {
        return styles.styles_right_border + " " + styles.styles_left_border;
      }
      return leftBorderRemove
        ? styles.styles_right_border
        : rightBorderRemove
          ? styles.styles_left_border
          : "";
    }

    return isSelectedIfRepeatTypeHasValue
      ? styles.selected_date_border +
          " " +
          styles.styles_bottom_border +
          " " +
          (leftBorderRemove && rightBorderRemove
            ? styles.both
            : leftBorderRemove
              ? styles.left
              : rightBorderRemove
                ? styles.right
                : "")
      : "";
  } else {
    return "";
  }
};
/**
 * Whether an event's assigned tags match the search term.
 * @param {object} event
 * @param {string} search lower-cased search term
 * @returns {boolean}
 */
const eventTagsMatchSearch = (event, search) => {
  const tags = event?.eventTags;
  if (!tags) return false;
  if (Array.isArray(tags)) {
    return tags.some((tag) => tag?.toLowerCase().includes(search));
  }
  return String(tags).toLowerCase().includes(search);
};

// Utility to filter events by search
export function filterEventsBySearch(
  events,
  staff,
  searchValue,
  matchingStaff,
) {
  let search = searchValue?.trim().toLowerCase();
  if (!search) return events;
  search = search.toLowerCase();
  if (search === "shift") {
    return events.filter((e) => e.isShift || eventTagsMatchSearch(e, search));
  }
  if (search === "event")
    return events.filter(
      (e) =>
        (e.agendaType === constants.agendaType.EVENT && !e.isShift) ||
        eventTagsMatchSearch(e, search),
    );
  if (search === "busy")
    return events.filter(
      (e) =>
        e.agendaType === constants.agendaType.BUSY_SLOT ||
        e.agendaType === constants.agendaType.BLOCKED ||
        e._type === "busySlot" ||
        eventTagsMatchSearch(e, search),
    );
  if (search.includes("leave"))
    return events.filter(
      (e) =>
        e.agendaType === constants.agendaType.LEAVE ||
        e._type === "leave" ||
        eventTagsMatchSearch(e, search),
    );
  if (search.includes("patient") || search.includes("appointment"))
    return events.filter(
      (e) =>
        e.agendaType === constants.agendaType.APPOINTMENT ||
        e._type === "appointment" ||
        eventTagsMatchSearch(e, search),
    );
  if (matchingStaff) {
    // 1. Find all staff whose names match the search
    const matchingStaffIds = events.reduce((prev, e) => {
      if (
        e.user &&
        ((e.user.firstName || "") + " " + (e.user.lastName || ""))
          .toLowerCase()
          .includes(search)
      ) {
        prev.set(e.user.id, e.user.id);
      }
      return prev;
    }, new Map());

    // 2. If any staff match, show all their events
    if (matchingStaffIds.size > 0) {
      return events.filter((e) => e.user && matchingStaffIds.has(e.user.id));
    }
    // 3. Otherwise, fall back to event title / tag search
    return events.filter(
      (e) =>
        (e.title && e.title.toLowerCase().includes(search)) ||
        eventTagsMatchSearch(e, search) ||
        (e.reasonForBlock && e.reasonForBlock.toLowerCase().includes(search)) ||
        (e.user &&
          ((e.user.firstName + " " + e.user.lastName)
            .toLowerCase()
            .includes(search) ||
            (e.user.fullName &&
              e.user.fullName.toLowerCase().includes(search)))),
    );
  }
  return events.filter(
    (e) =>
      (e.title && e.title.toLowerCase().includes(search)) ||
      eventTagsMatchSearch(e, search) ||
      (e.reasonForBlock && e.reasonForBlock.toLowerCase().includes(search)) ||
      (staff &&
        ((staff.user?.firstName + " " + staff.user?.lastName)
          .toLowerCase()
          .includes(search) ||
          (staff.fullName && staff.fullName.toLowerCase().includes(search)))),
  );
}
export const filteringMethodForEventShiftOthers = (
  agendaTypes,
  item,
  ownerId,
  showEnterpriseEvents = false,
) => {
  if (agendaTypes?.length > 0 || showEnterpriseEvents) {
    let eventsCreatedByUser = [];
    let eventsNotCreatedByUser = [];
    let filteredSchedulerEvents = [];
    let shiftsCreatedByUser = [];
    let shiftsCreatedByOthers = [];
    let eventsNotAccepted = [];
    let shiftsNotAccepted = [];

    // Events
    if (agendaTypes.includes(0)) {
      eventsCreatedByUser =
        item?.schedulerEvents?.filter(
          (event) => !event?.isShift && event?.createdById === ownerId,
        ) || [];
    }
    if (agendaTypes.includes(-1)) {
      eventsNotCreatedByUser =
        item?.schedulerEvents?.filter(
          (event) => !event?.isShift && event?.createdById !== ownerId,
        ) || [];
    }
    // Events Not Accepted (type 4)
    if (agendaTypes.includes(4)) {
      eventsNotAccepted =
        item?.schedulerEvents?.filter(
          (event) =>
            !event?.isShift &&
            event?.eventStatus === constants.SCHEDULERSTATUS.PENDING,
        ) || [];
    }
    // Shifts
    if (agendaTypes.includes(8)) {
      shiftsCreatedByUser =
        item?.schedulerEvents?.filter(
          (event) => event?.isShift && event?.createdById === ownerId,
        ) || [];
    }
    if (agendaTypes.includes(6)) {
      shiftsCreatedByOthers =
        item?.schedulerEvents?.filter(
          (event) => event?.isShift && event?.createdById !== ownerId,
        ) || [];
    }
    // Shifts Not Accepted (type 7)
    if (agendaTypes.includes(7)) {
      shiftsNotAccepted =
        item?.schedulerEvents?.filter(
          (event) =>
            event?.isShift &&
            event?.eventStatus === constants.SCHEDULERSTATUS.PENDING,
        ) || [];
    }

    // Existing event type filter (agendaType)
    filteredSchedulerEvents =
      item?.schedulerEvents?.filter((event) => {
        // If only event filters are selected, exclude shifts
        if (showEnterpriseEvents && event.isEnterprise) return true;
        if (
          agendaTypes.includes(4) && // Events Not Accepted
          !agendaTypes.includes(7) // Shifts Not Accepted not selected
        ) {
          return agendaTypes.includes(event.agendaType) && !event.isShift;
        }
        // If only shift filters are selected, exclude events
        if (
          agendaTypes.includes(7) && // Shifts Not Accepted
          !agendaTypes.includes(4) // Events Not Accepted not selected
        ) {
          return agendaTypes.includes(event.agendaType) && event.isShift;
        }
        // Otherwise, include all matching agendaTypes
        return agendaTypes.includes(event.agendaType);
      }) || [];

    // Merge and deduplicate events by id
    const mergedEvents = [
      ...eventsCreatedByUser,
      ...eventsNotCreatedByUser,
      ...eventsNotAccepted,
      ...shiftsCreatedByUser,
      ...shiftsCreatedByOthers,
      ...shiftsNotAccepted,
      ...filteredSchedulerEvents,
    ];
    const uniqueEvents = mergedEvents.filter(
      (event, index, self) =>
        event?.id && index === self.findIndex((e) => e && e.id === event.id),
    );

    return {
      ...item,
      schedulerEvents: uniqueEvents,
      appointments:
        item?.appointments?.filter(
          (event) =>
            agendaTypes.includes(event.agendaType) ||
            (showEnterpriseEvents && event?.isEnterprise),
        ) || [],
      appointmentSlots:
        item?.appointmentSlots?.filter(
          (event) =>
            agendaTypes.includes(event.agendaType) ||
            (showEnterpriseEvents && event?.isEnterprise),
        ) || [],
      leaves:
        item?.leaves?.filter(
          (event) =>
            matchForLeaves(event, agendaTypes) ||
            (showEnterpriseEvents && event?.isEnterprise),
        ) || [],
      schedulerBusySlots: (
        item?.schedulerBusySlots?.filter(
          (event) =>
            agendaTypes.includes(event.agendaType) ||
            (showEnterpriseEvents && event?.isEnterprise) ||
            (agendaTypes.includes(constants.agendaType.BUSY_SLOT) &&
              event.agendaType === constants.agendaType.BLOCKED),
        ) || []
      ).concat(
        item?.appointmentSlots?.filter(
          (event) =>
            (agendaTypes.includes(constants.agendaType.BUSY_SLOT) &&
              event.agendaType === constants.agendaType.BLOCKED) ||
            (showEnterpriseEvents && event?.isEnterprise),
        ) || [],
      ),
    };
  }
  return {
    schedulerEvents: [],
    appointments: [],
    leaves: [],
    schedulerBusySlots: [],
    appointmentSlots: [],
    ...item,
  };
};

const getDifferentEvents = (events = []) => {
  const allDayEvents = [];
  const otherEvents = [];
  if (Array.isArray(events)) {
    for (const event of events) {
      event?.isAllDayEvent ? allDayEvents.push(event) : otherEvents.push(event);
    }
  }

  return [allDayEvents, otherEvents];
};

const withType = (item, fallbackType) => ({
  ...item,
  _type: item._type || fallbackType,
});

export const addAllItemsTypes = ({
  schedulerEvents,
  appointments,
  schedulerBusySlots,
  appointmentSlots,
  leaves,
}) => {
  // handled case for null
  schedulerEvents = schedulerEvents ?? [];
  appointments = appointments ?? [];
  schedulerBusySlots = schedulerBusySlots ?? [];
  appointmentSlots = appointmentSlots ?? [];
  leaves = leaves ?? [];
  const [allDayEvents, allOtherEvents] = getDifferentEvents(schedulerEvents);

  const items = [
    ...appointments.map((e) => {
      e.uniqueKye = uuidv4();
      return withType(e, "appointment");
    }),
    ...schedulerBusySlots.map((e) => {
      e.uniqueKye = uuidv4();
      return withType(e, "busySlot");
    }),
    ...allOtherEvents.map((e) => {
      e.uniqueKye = uuidv4();
      return withType(e, e.isShift ? "schedulerEvent" : "event");
    }),
    ...appointmentSlots.map((e) => {
      e.uniqueKye = uuidv4();
      return withType(e, "busySlot");
    }),
  ];

  // Sort by start time descending
  items.sort((a, b) => new Date(b.startTime) - new Date(a.startTime));

  const allItems = [
    ...leaves.map((e) => {
      e.uniqueKye = uuidv4();
      return withType(e, "leave");
    }),
    ...allDayEvents.map((e) => {
      e.uniqueKye = uuidv4();
      return withType(e, e.isShift ? "schedulerEvent" : "event");
    }),
    ...items,
  ];

  return allItems;
};

/**
 * @param {{ user?: { id?: number, fullName?: string }, userId?: number, userName?: string }} item
 */
const getStaffSortName = (item) => item?.user?.fullName ?? item?.userName ?? "";

/**
 * @param {{ user?: { id?: number }, userId?: number }} item
 */
const getStaffSortId = (item) => item?.user?.id ?? item?.userId;

/**
 * Resolves employment/join date for staff-row sorting.
 * @param {{ user?: Record<string, unknown> }} item
 * @returns {number} epoch ms, or 0 when missing/invalid
 */
const getStaffEmploymentTimestamp = (item) => {
  const user = item?.user || {};
  const raw = user.employmentDate ?? null;
  if (raw == null || raw === "") return 0;
  const ts = new Date(raw).getTime();
  return Number.isNaN(ts) ? 0 : ts;
};

/**
 * Compare staff for display order: logged-in user first, then alphabetical by name.
 * @param {{ user?: { id?: number, fullName?: string }, userId?: number, userName?: string }} a
 * @param {{ user?: { id?: number, fullName?: string }, userId?: number, userName?: string }} b
 * @param {number|string} [currentUserId]
 */
export function compareStaffWithCurrentUserFirst(a, b, currentUserId) {
  const currentId =
    currentUserId != null && currentUserId !== ""
      ? Number(currentUserId)
      : null;
  const aId = Number(getStaffSortId(a));
  const bId = Number(getStaffSortId(b));

  if (currentId != null && !Number.isNaN(currentId)) {
    if (aId === currentId && bId !== currentId) return -1;
    if (bId === currentId && aId !== currentId) return 1;
  }

  return getStaffSortName(a).localeCompare(getStaffSortName(b), undefined, {
    sensitivity: "base",
  });
}

/**
 * Compare staff rows for Event Workspace weekly sort options.
 * @param {{ user?: Record<string, unknown>, userId?: number, userName?: string }} a
 * @param {{ user?: Record<string, unknown>, userId?: number, userName?: string }} b
 * @param {string} sortOption - EVENT_WEEKLY_SORT value
 * @param {number|string} [currentUserId]
 */
export function compareStaffByWeeklySortOption(
  a,
  b,
  sortOption,
  currentUserId,
) {
  switch (sortOption) {
    case "nameAsc":
      return getStaffSortName(a).localeCompare(getStaffSortName(b), undefined, {
        sensitivity: "base",
      });
    case "nameDesc":
      return getStaffSortName(b).localeCompare(getStaffSortName(a), undefined, {
        sensitivity: "base",
      });
    case "employmentLatest": {
      const aTs = getStaffEmploymentTimestamp(a);
      const bTs = getStaffEmploymentTimestamp(b);
      // Missing dates sort last for "latest first"
      if (aTs === 0 && bTs !== 0) return 1;
      if (bTs === 0 && aTs !== 0) return -1;
      const diff = bTs - aTs;
      if (diff !== 0) return diff;
      return getStaffSortName(a).localeCompare(getStaffSortName(b), undefined, {
        sensitivity: "base",
      });
    }
    case "employmentOldest": {
      const aTs = getStaffEmploymentTimestamp(a);
      const bTs = getStaffEmploymentTimestamp(b);
      // Missing dates sort last for "oldest first"
      if (aTs === 0 && bTs !== 0) return 1;
      if (bTs === 0 && aTs !== 0) return -1;
      const diff = aTs - bTs;
      if (diff !== 0) return diff;
      return getStaffSortName(a).localeCompare(getStaffSortName(b), undefined, {
        sensitivity: "base",
      });
    }
    case "default":
    default:
      return compareStaffWithCurrentUserFirst(a, b, currentUserId);
  }
}

/**
 * @param {Array} list
 * @param {number|string} [currentUserId]
 */
export function sortStaffWithCurrentUserFirst(list, currentUserId) {
  return [...list].sort((a, b) =>
    compareStaffWithCurrentUserFirst(a, b, currentUserId),
  );
}

/**
 * Normalizes a value to a positive office id for scheduler employee payloads.
 * @param {number|string|null|undefined} value
 * @returns {number|null}
 */
export function normalizeSchedulerOfficeId(value) {
  if (value == null || value === "") return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
}

/**
 * Resolves officeId when reassigning an event/shift to another staff row via drag-drop.
 *
 * @param {{
 *   dropContext?: { targetOfficeId?: number|string },
 *   eventData?: { officeId?: number|string, eventEmployees?: Array },
 *   originalActiveEmployees?: Array,
 *   sourceUserId?: number|string,
 *   apiOfficeIds?: Array<number|string>,
 * }} options
 * @returns {number|null}
 */
export function resolveDragDropTargetOfficeId({
  dropContext,
  eventData,
  originalActiveEmployees = [],
  sourceUserId,
  apiOfficeIds = [],
} = {}) {
  const fromDrop = normalizeSchedulerOfficeId(dropContext?.targetOfficeId);
  if (fromDrop) return fromDrop;

  const fromEvent = normalizeSchedulerOfficeId(eventData?.officeId);
  if (fromEvent) return fromEvent;

  if (sourceUserId != null) {
    const sourceEmployee = originalActiveEmployees.find(
      (employee) =>
        String(employee?.userId ?? employee?.user?.id) === String(sourceUserId),
    );
    const fromSource = normalizeSchedulerOfficeId(sourceEmployee?.officeId);
    if (fromSource) return fromSource;
  }

  const fromAnyEmployee = originalActiveEmployees
    .map((employee) => normalizeSchedulerOfficeId(employee?.officeId))
    .find(Boolean);
  if (fromAnyEmployee) return fromAnyEmployee;

  if (Array.isArray(apiOfficeIds) && apiOfficeIds.length === 1) {
    return normalizeSchedulerOfficeId(apiOfficeIds[0]);
  }

  return null;
}

const EMPTY_OFFICE_SCHEDULER_ROW_FIELDS = {
  appointments: [],
  appointmentSlots: [],
  leaves: [],
  schedulerBusySlots: [],
};

/**
 * @param {object} user
 * @param {Array} [schedulerEvents]
 */
function buildOfficeSchedulerRow(user, schedulerEvents = []) {
  return {
    user,
    schedulerEvents,
    ...EMPTY_OFFICE_SCHEDULER_ROW_FIELDS,
  };
}

/**
 * Maps `ListForAssignerByEmployee` into the OfficeScheduler agenda shape used by staff weekly grids.
 *
 * Supports:
 * - Grouped format: `{ requestedDate, userEventListForAssignerList: [{ user, schedulerEvents }] }`
 * - Legacy format: `{ date, schedulerEvents: [{ userId, userName, ... }] }`
 *
 * @param {Array|object} apiDays
 * @param {{ startDate?: string, endDate?: string, currentUserId?: number|string, allowedUserIds?: Array<number|string> }} [range]
 * @returns {Array<{ requestedDate: string, holidayList: [], officeSchedulerList: Array }>}
 */
export function mapAssignerByEmployeeToOfficeAgenda(apiDays = [], range = {}) {
  const normalizedDays = Array.isArray(apiDays)
    ? apiDays
    : apiDays
      ? [apiDays]
      : [];
  const { currentUserId, allowedUserIds, startDate, endDate } = range;
  const allowedUserIdSet =
    Array.isArray(allowedUserIds) && allowedUserIds.length > 0
      ? new Set(allowedUserIds.map((id) => String(id)))
      : null;

  const usesGroupedFormat = normalizedDays.some((day) =>
    Array.isArray(day?.userEventListForAssignerList),
  );

  const agendaByDate = new Map();
  let sortedUsers = [];

  if (usesGroupedFormat) {
    const userMap = new Map();

    normalizedDays.forEach((day) => {
      (day?.userEventListForAssignerList || []).forEach((entry) => {
        const user = entry?.user;
        if (!user?.id) return;
        if (allowedUserIdSet && !allowedUserIdSet.has(String(user.id))) {
          return;
        }
        const existing = userMap.get(user.id);
        userMap.set(user.id, existing ? { ...existing, ...user } : user);
      });
    });

    sortedUsers = sortStaffWithCurrentUserFirst(
      [...userMap.values()].map((user) => ({ user })),
      currentUserId,
    ).map((entry) => entry.user);

    normalizedDays.forEach((day) => {
      const requestedDate = moment(day?.requestedDate || day?.date).format(
        "YYYY-MM-DD",
      );
      const entriesByUserId = new Map();

      (day?.userEventListForAssignerList || []).forEach((entry) => {
        const userId = entry?.user?.id;
        if (!userId) return;
        if (allowedUserIdSet && !allowedUserIdSet.has(String(userId))) {
          return;
        }
        entriesByUserId.set(userId, entry);
      });

      agendaByDate.set(requestedDate, {
        requestedDate,
        holidayList: day?.holidayList || [],
        officeSchedulerList: sortedUsers.map((user) =>
          buildOfficeSchedulerRow(
            user,
            entriesByUserId.get(user.id)?.schedulerEvents || [],
          ),
        ),
      });
    });
  } else {
    const legacyUserMap = new Map();

    normalizedDays.forEach((day) => {
      (day?.schedulerEvents || []).forEach((event) => {
        if (!event?.userId) return;
        if (allowedUserIdSet && !allowedUserIdSet.has(String(event.userId))) {
          return;
        }
        const existing = legacyUserMap.get(event.userId);
        legacyUserMap.set(event.userId, {
          userId: event.userId,
          userName: event.userName || existing?.userName || "",
        });
      });
    });

    const sortedLegacyUsers = sortStaffWithCurrentUserFirst(
      [...legacyUserMap.values()],
      currentUserId,
    );

    normalizedDays.forEach((day) => {
      const requestedDate = moment(day?.date || day?.requestedDate).format(
        "YYYY-MM-DD",
      );
      const eventsByUserId = (day?.schedulerEvents || []).reduce(
        (acc, event) => {
          if (!event?.userId) return acc;
          if (allowedUserIdSet && !allowedUserIdSet.has(String(event.userId))) {
            return acc;
          }
          if (!acc[event.userId]) acc[event.userId] = [];
          acc[event.userId].push(event);
          return acc;
        },
        {},
      );

      agendaByDate.set(requestedDate, {
        requestedDate,
        holidayList: day?.holidayList || [],
        officeSchedulerList: sortedLegacyUsers.map(({ userId, userName }) =>
          buildOfficeSchedulerRow(
            {
              id: userId,
              fullName: userName || "",
            },
            eventsByUserId[userId] || [],
          ),
        ),
      });
    });

    sortedUsers = sortedLegacyUsers.map(({ userId, userName }) => ({
      id: userId,
      fullName: userName || "",
    }));
  }

  if (!startDate || !endDate) {
    return [...agendaByDate.values()];
  }

  const filledDays = [];
  const cursor = moment(startDate).startOf("day");
  const last = moment(endDate).startOf("day");

  while (cursor.isSameOrBefore(last, "day")) {
    const key = cursor.format("YYYY-MM-DD");
    filledDays.push(
      agendaByDate.get(key) || {
        requestedDate: key,
        holidayList: [],
        officeSchedulerList: sortedUsers.map((user) =>
          buildOfficeSchedulerRow(user),
        ),
      },
    );
    cursor.add(1, "day");
  }

  return filledDays;
}

/**
 * Whether the event/shift card action menu (three dots) should be visible.
 *
 * @param {object} event - Scheduler event/shift item
 * @param {object} profile - Current user profile
 * @param {{ isOwner?: boolean, canEditAndViewOthersData?: (officeId: number) => boolean }} [options]
 * @returns {boolean}
 */
/** True when the event belongs in the calendar all-day row (not the time grid). */
export function isSchedulerAllDaySlotEvent(event) {
  if (!event) return false;
  return Boolean(event.isAllDayEvent || event.isAllDayBusy);
}

/** True when the event should render in the timed grid (has start/end and is not all-day). */
export function isSchedulerTimedSlotEvent(event) {
  if (!event || isSchedulerAllDaySlotEvent(event)) return false;
  return Boolean(event.startTime && event.endTime);
}

export function canShowEventCardMenu(event, profile, options = {}) {
  if (!event || !profile) return false;

  const { isOwner = false, canEditAndViewOthersData } = options;
  const isAdmin = Boolean(profile?.isAdmin);
  const isAccountOwner =
    profile?.role?.systemRole === constants.systemRoles.accountOwner;
  const createdByMe = event?.createdById === profile?.id;
  const createdByOthers = event?.isShift && profile?.id !== event?.createdById;

  if (isAccountOwner || isAdmin || isOwner) return true;
  if (createdByMe) return true;
  if (createdByOthers && canEditAndViewOthersData?.(event?.officeId)) {
    return true;
  }

  return false;
}
